// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
    accessoryRepairSelector,
    deviceRepairSelector,
    isFullDeviceRepairSelector
} from './../../../store/orderCreation/selectors';

import RepairItemDetail from './../../../components/RepairItemDetail/RepairItemDetail';

import Styles from './styles.module.scss';

export default function SelectedRepairItemsDetails() {
    const { t } = useTranslation();
    const deviceItems = useSelector(state => deviceRepairSelector(state));
    const accessories = useSelector(state => accessoryRepairSelector(state));
    const isFullDeviceRepair = useSelector(state => isFullDeviceRepairSelector(state));

    function renderDeviceSection() {
        if (!Object.keys(deviceItems).length) {
            return null;
        }
        const deviceData = Object.keys(deviceItems).map((skuKey: string) => {
            const item = deviceItems[skuKey];
            return {
                name: item.name,
                problemDescription: item.problemDescription,
                problemType: item.problemType?.name,
                serialNumber: item.serialNumber,
                sku: isFullDeviceRepair ? item.sku : item.symptomCode,
                numberOfRepairAttempts: item.numberOfRepairAttempts,
                repairDetails: item.repairDetails,
            };
        });
        return (
            <section className={Styles.parentSection}>
                <h3 className={Styles.h3Heading}>{t('device')}</h3>
                <RepairItemDetail
                    data={deviceData}
                    title={t('device')}
                />
            </section>
        );
    }

    function renderAccessorySection() {
        if (!accessories || !Object.keys(accessories).length) {
            return null;
        }

        const accessoryData = Object.keys(accessories).map((skuKey: string) => {
            const { data, problemDescription } = accessories[skuKey];
            return {
                problemDescription,
                name: data.name,
            };
        });
        return (
            <section
                className={`${Styles.parentSection} ${Styles.sectionSeparator}`}
            >
                <h3 className={Styles.accessoryHeading}>{t('accessory')}</h3>
                <RepairItemDetail
                    data={accessoryData}
                    title={t('accessory')}
                />
            </section>
        );
    }

    return (
        <>
            {renderDeviceSection()}
            {renderAccessorySection()}
        </>
    );
}
